import React from 'react';

import { ImportTestCasesStatusContext } from '@qality/common-components/src/lib/ImportTestCasesStatusProvider';
import { StorageOfUniqueServices } from '@qality/common-service';

import { SeeCreatedTestsView } from './SeeCreatedTests.view';

export const SeeCreatedTests = () => {
  const { importResponse } = React.useContext(ImportTestCasesStatusContext);

  const showCreatedIssues = () => {
    const keys = importResponse.success?.map(
      (successItem) => successItem.testCaseKey
    );
    if (keys) {
      window.open(
        StorageOfUniqueServices.get('URLService').getUrlToSearchIssues(keys),
        '_blank'
      );
    }
  };

  return <SeeCreatedTestsView handleClick={showCreatedIssues} />;
};
